module.exports = __webpack_public_path__ + "img/feedback-o.5ef2bd6e.svg";